'use client'

import { useEffect } from 'react'

const ZoomDisabler = () => {
  useEffect(() => {
    // Prevent pinch-to-zoom on touch devices
    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    }

    // Prevent keyboard zoom (Ctrl/Cmd + +/-)
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
        e.preventDefault()
      }
    }

    // Prevent mouse wheel zoom (Ctrl/Cmd + wheel)
    const handleWheel = (e: WheelEvent) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault()
      }
    }

    // Prevent double-tap zoom on iOS
    let lastTouchEnd = 0
    const handleTouchEnd = (e: TouchEvent) => {
      const now = Date.now()
      if (now - lastTouchEnd <= 300) {
        e.preventDefault()
      }
      lastTouchEnd = now
    }

    // Add event listeners
    document.addEventListener('touchmove', handleTouchMove, { passive: false })
    document.addEventListener('keydown', handleKeyDown, { passive: false })
    document.addEventListener('wheel', handleWheel, { passive: false })
    document.addEventListener('touchend', handleTouchEnd, { passive: false })

    // Cleanup
    return () => {
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('wheel', handleWheel)
      document.removeEventListener('touchend', handleTouchEnd)
    }
  }, [])

  return null
}

export default ZoomDisabler
